// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__XNuTX","active":"Pagination_active__HgZJh"};